export const PokemonListStyle = {
    display: 'flex',
    flexWrap: 'wrap',
    margin: 'auto',
    padding: '10px',
    justifyContent: 'center',
    color: '#3B4CCA'
}
export const pagination = {
    display: 'flex',
    justifyContent: 'center',
    gap: '10px',
    margin: '10px'
}
export const button = {
    backgroundColor: '#3B4CCA',
    color: 'white',
    border: '0px',
    borderRadius: '5px',
    padding: '10px',
    margin: '10px',
    '&:hover': {
        cursor: 'pointer',
        backgroundColor: '#1f32b3',
        boxShadow: '0 0 5px 5px'
    }

}